// Exportaciones centralizadas de todos los stores de Pinia
export { useAuthStore, userHelper } from './auth'
export { useProductsStore } from './products'
export { useCustomersStore } from './customers'
export { useSysconfStore } from './sysconf'
export { useInvoicesStore } from './invoices'
export { useRolesPermissionStore } from './rolesPermission'
export { useUserStore } from './user'

// Función helper para inicializar todos los stores desde sessionStorage
export const initializeStoresFromSession = () => {
  // Importar dinámicamente para evitar problemas de dependencias circulares
  import('./auth').then(({ useAuthStore }) => {
    const authStore = useAuthStore()
    authStore.tryVeryLogin()
  })

  import('./products').then(({ useProductsStore }) => {
    const productsStore = useProductsStore()
    productsStore.loadProductsFromSession()
  })

  import('./customers').then(({ useCustomersStore }) => {
    const customersStore = useCustomersStore()
    customersStore.loadCustomersFromSession()
  })

  import('./sysconf').then(({ useSysconfStore }) => {
    const sysconfStore = useSysconfStore()
    sysconfStore.trySysconfs()
    sysconfStore.tryListCities()
  })

  import('./invoices').then(({ useInvoicesStore }) => {
    const invoicesStore = useInvoicesStore()
    invoicesStore.loadNumerationFromSession()
    invoicesStore.loadInvoicesFromSession()
  })

  import('./rolesPermission').then(({ useRolesPermissionStore }) => {
    const rolesStore = useRolesPermissionStore()
    rolesStore.loadAllFromSession()
  })

  import('./user').then(({ useUserStore }) => {
    const userStore = useUserStore()
    userStore.loadAllUserData()
  })
}

// Función helper para limpiar todos los stores (útil para logout)
export const clearAllStores = () => {
  import('./auth').then(({ useAuthStore }) => {
    const authStore = useAuthStore()
    authStore.getLogout()
  })

  import('./products').then(({ useProductsStore }) => {
    const productsStore = useProductsStore()
    productsStore.clearProducts()
  })

  import('./customers').then(({ useCustomersStore }) => {
    const customersStore = useCustomersStore()
    customersStore.clearCustomers()
  })

  import('./sysconf').then(({ useSysconfStore }) => {
    const sysconfStore = useSysconfStore()
    sysconfStore.clearConfig()
  })

  import('./invoices').then(({ useInvoicesStore }) => {
    const invoicesStore = useInvoicesStore()
    invoicesStore.clearInvoices()
  })

  import('./rolesPermission').then(({ useRolesPermissionStore }) => {
    const rolesStore = useRolesPermissionStore()
    rolesStore.clearRolesPermission()
  })

  import('./user').then(({ useUserStore }) => {
    const userStore = useUserStore()
    userStore.clearUser()
  })
}